const random_number_DRONES = new Random_Number( { max_attempts: 50, max: 30, min: 1 } );
const drone_counter = ecommerce_counter( '.e-commerce__num-drones', 15000, random_number_DRONES );

drone_counter( drone_counter, true );